export default {
    common: {
        title: 'Modifica immagine',
        cancel: 'Cancella',
        save: 'Salva',
        crop: 'Raccolto',
        adjustments: 'Regolazioni',
        filters: 'Filtri',
        frames: 'Cornici',
        overlays: 'Sovrapposizioni',
        text: 'Testo',
        stickers: 'Adesivi',
        brush: 'Spazzola',
        ai: "Crea immagine usando l'IA",
        reset: 'Ripristino',
        comingSoon: 'Prossimamente...',
        apply: 'Applicare',
        undo: 'Annulla',
        redo: 'Rifare',
        flipHorizontal: 'Capovolgi Orizzontalmente',
        flipVertical: 'Inverti Verticalmente',
        rotateClockwise: 'Ruota verso destra',
        rotateAntiClockwise: 'Ruota in senso antiorario',
        warning: 'Attenzione',
        discard: 'Scartare',
        continue: 'Continua a modificare',
        discardHeading: 'Scartare le modifiche?',
        discardSubHeading: "Se chiudi l'editor di immagini, le tue modifiche non verranno salvate",
        subtitle: 'I formati di immagine supportati sono PNG e JPEG',
        clone: 'Clona',
        delete: 'Elimina',
    },
};
